/**
 * Status "Pendente": na criação o servidor grava "Aberto" só quando os campos obrigatórios do tipo
 * já vieram preenchidos. Incidentes (problemas) e solicitação de serviços nascem Pendente, porque
 * parte da triagem só existe na edição do card. Ao salvar o card completo, o servidor passa para
 * "Aberto". Mesma regra de api/utils/ticketPendente.js (o servidor é quem decide; aqui é só para orientar o editor).
 */

export const STATUS_PENDENTE = 'Pendente';
const CHAVE_STATUS_PENDENTE = 'ticketCatalogo.status.pendente';

const TIPO_SUPORTE_SISTEMA = 'SUPORTE SISTEMA (MERUSTRAKER)';
const TIPO_SOLICITACAO_CANDIDATOS = 'SOLICITAÇÃO DE CANDIDATOS (AGÊNCIA)';

function preenchido(v) {
    return v !== undefined && v !== null && String(v).trim() !== '';
}

/** Ticket no Pendente. O status_dispatcher_extenso vem traduzido: a chave é o que não muda com o idioma. */
export function ticketEstaPendente(ticket) {
    if (!ticket) return false;
    if (ticket.status_dispatcher_chave) return ticket.status_dispatcher_chave === CHAVE_STATUS_PENDENTE;
    return String(ticket.status_dispatcher_extenso || '').trim() === STATUS_PENDENTE;
}

/** Equipes do ticket como lista: a API devolve id_equipes como CSV; a edição usa array ou id_equipe. */
function equipesDoTicket(ticket) {
    if (preenchido(ticket.id_equipe)) return [ticket.id_equipe];
    const ids = ticket.id_equipes;
    if (Array.isArray(ids)) return ids.filter(preenchido);
    if (typeof ids === 'number') return [ids];
    if (typeof ids === 'string') return ids.split(',').map((s) => s.trim()).filter(preenchido);
    return [];
}

/** Chaves dos campos obrigatórios ainda vazios (mesmas chaves que updateticket devolve em campos_pendentes). */
export function camposObrigatoriosFaltantes(ticket, nomeTipoTicket) {
    if (!ticket) return [];
    const tipo = String(nomeTipoTicket || '').trim().toUpperCase();
    if (tipo === TIPO_SOLICITACAO_CANDIDATOS) {
        return preenchido(ticket.id_tipo_solicitacao) ? [] : ['id_tipo_solicitacao'];
    }
    const faltantes = [];
    if (tipo === TIPO_SUPORTE_SISTEMA && !preenchido(ticket.id_tipo_solicitacao)) faltantes.push('id_tipo_solicitacao');
    if (!preenchido(ticket.id_familia_atendimento)) faltantes.push('id_familia_atendimento');
    if (!preenchido(ticket.id_tipo_atendimento)) faltantes.push('id_tipo_atendimento');
    if (!preenchido(ticket.id_servico)) faltantes.push('id_servico');
    if (equipesDoTicket(ticket).length === 0) faltantes.push('id_equipes');
    return faltantes;
}

/** Rótulo i18n de cada campo obrigatório (Tipo de problema no suporte sistema). */
export function campoPendenteLabelKey(campo, isSuporteSistema) {
    switch (campo) {
        case 'id_tipo_solicitacao':
            return isSuporteSistema ? 'ticketSuporteSistema.fields.tipoProblema' : 'ticket.createDialog.fields.tipoSolicitacao.label';
        case 'id_familia_atendimento':
            return 'ticket.createDialog.fields.familiaAtendimento.label';
        case 'id_tipo_atendimento':
            return 'ticket.createDialog.fields.tipoAtendimento.label';
        case 'id_servico':
            return 'ticket.createDialog.fields.servico.label';
        case 'id_equipes':
            return 'ticket.team.title';
        default:
            return null;
    }
}
